import React from "react"
import { graphql } from "gatsby"
import { GoogleAnalytics } from "../analytics"
import moment from "moment"
import { get } from "lodash"
import loadable from "@loadable/component"
import "antd/dist/antd.css"

import Layout from "../Layouts/Layout"
import PageHead from "../Layouts/PageHead"
import sections from "../Sections"
import NewHeader from "../Sections/New/NewHeader"
import withQueryString from "../highOrderComponents/withQueryString"
import withLocalStorage from "../highOrderComponents/withLocalStorage"
import "../components/layout.beta.css"

const NewFooter = loadable(() => import("../Sections/New/NewFooter"))
require("moment/locale/de")

const FormPage = props => {
  let pageState = {
    ...props.location.state,
  }

  // Take current session state
  if (!props.localStorage) {
    props.setLocalStorage({
      createdAt: moment(),
      ...props.queryString,
    })
  } else if (
    (props.localStorage.createdAt &&
      moment().diff(moment(props.localStorage.createdAt), "hours") > 10) ||
    !props.localStorage.createdAt
  ) {
    props.setLocalStorage(null)
  } else {
    props.setLocalStorage({
      ...props.localStorage,
      ...props.queryString,
    })
  }

  const localStorage = props.getLocalStorage() || {}

  if (pageState) {
    delete pageState["key"]
  }

  return (
    <React.Fragment>
      <GoogleAnalytics trackingId="UA-146103271-1" gtmId="GTM-MPC77P2" />
      <PageHead
        title={get(props, "data.sanityPage.title", "")}
        metaTags={get(props, "data.sanityPage.metaTags", "")}
      />
      {(props.data.sanityPage.newHeader ||
        (props.data.sanityPage.header &&
          props.data.sanityPage.header.name === "NewHeader")) && (
        <NewHeader
          {...props.data.sanityPage.newHeader}
          backgroundTheme={get(props, "data.sanityPage.backgroundTheme", null)}
          additionalInfo={get(
            props,
            "data.sanityPage.newFooter.additionalInfo",
            null
          )}
        />
      )}
      <Layout theme="form">
        {props.data.sanityPage.sections.data.map((section, index) => {
          try {
            let sectionType = section.__typename.replace("Sanity", "")
            sectionType =
              sectionType.charAt(0).toLowerCase() + sectionType.slice(1)

            const Section = sections[sectionType]

            return (
              Section && (
                <Section
                  backgroundTheme={get(
                    props,
                    "data.sanityPage.backgroundTheme",
                    null
                  )}
                  key={`${section.__typename}-${index}`}
                  {...section}
                  state={{
                    ...pageState,
                    meta: { ...get(pageState, "meta", {}), ...localStorage },
                  }}
                />
              )
            )
          } catch (err) {
            return null
          }
        })}
        {(props.data.sanityPage.newFooter ||
          (props.data.sanityPage.footer &&
            props.data.sanityPage.footer.name === "NewFooter")) && (
          <NewFooter
            {...props.data.sanityPage.newFooter}
            backgroundTheme={get(
              props,
              "data.sanityPage.backgroundTheme",
              null
            )}
          />
        )}
      </Layout>
    </React.Fragment>
  )
}

export default withLocalStorage("state")(withQueryString(FormPage))

export const query = graphql`
  query ($slug: String!) {
    sanityPage(slug: { current: { eq: $slug } }) {
      title
      backgroundTheme
      sections {
        data {
          __typename

          ... on SanityIntroduction {
            headline
            subheadline
            backgroundImage {
              asset {
                gatsbyImageData(
                  placeholder: BLURRED
                  layout: CONSTRAINED
                  width: 700
                )
              }
            }
            ctas {
              text
              state {
                code
              }
              externalLink
              internalLink {
                slug {
                  current
                }
              }
            }
          }

          ... on SanityFormNavigator {
            _key
            name
            retrieveUrl
            updateUrl
            formGroups {
              description
              name
              forms {
                name
                description
                submissionIdentifier
                forms {
                  _id
                }
                condition {
                  formReference {
                    form {
                      _id
                    }
                    variable
                  }
                  operator
                  value
                }
                conditions {
                  formReference {
                    form {
                      _id
                    }
                    variable
                  }
                  operator
                  value
                }
                multiplier {
                  form {
                    _id
                    name
                  }
                  variable
                }
              }
            }
          }

          ... on SanityParagraph {
            headline
            text
            align
            button {
              state {
                code
              }
              text
              externalLink
              internalLink {
                slug {
                  current
                }
              }
            }
          }

          ... on SanityPhoneAction {
            headline
            phoneNumber
          }

          ... on SanityCustomerFeedback {
            headline
            subHeadline
            align
            widgetCode
          }

          ... on SanityNewCallToAction {
            headline
            headlineSize
            description
            image {
              asset {
                gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  width: 650
                )
              }
            }
            button {
              state {
                code
              }
              text
              externalLink
              internalLink {
                slug {
                  current
                }
              }
            }
          }

          ... on SanityForm {
            isNavigationFixed
            showProgress
            form {
              _id
              name
            }
          }
        }
      }
    }
  }
`
